// extracted by mini-css-extract-plugin
export default {"App":"App_App__KE0KK","wrapper":"App_wrapper__-2XNZ","fadeIn":"App_fadeIn__uFsPT"};